import { takeEvery, put, call } from "redux-saga/effects";
import apiCall from "../services";

const apiUrl = process.env.REACT_APP_API_URL;
const enviromentUrl = process.env.REACT_APP_ENVIROMENT;

const getSetCookie = () => {
  return window.localStorage.getItem("uuidSetCookie");
};

function* getWaiverList(actions) {
  const uuid = getSetCookie();

  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
    };

    let url =
      actions.query === null
        ? apiUrl + "/opa-waivers?page=" + actions.page
        : apiUrl + "/opa-waivers" + actions.query;

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "get", url, requestOptions);
    yield put({ type: "LIST_WAIVER_RESPONSE_GET", value: response });
  } catch (error) {
    yield put({ type: "LIST_WAIVER_RESPONSE_GET", value: error });
  }
}

function* getWaiver(actions) {
  const uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
    };

    let url = `${apiUrl}/opa-waiver/${actions.query}?include=products`;

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "get", url, requestOptions);

    yield put({ type: "WAIVER_RESPONSE_GET", value: response });
  } catch (error) {
    yield put({ type: "WAIVER_RESPONSE_GET", value: error });
  }
}

function* resetWaiver() {
  yield put({ type: "WAIVER_RESPONSE_RESET" });
}

function* addWaiver(actions) {
  const uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
      body: JSON.stringify(actions.form),
    };

    let url = apiUrl + "/opa-waiver";

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "POST", url, requestOptions);

    let responseStatus = "warning";
    if (response) {
      if (response.createdAt || response.uuid) {
        responseStatus = "success";
      } else {
        responseStatus = "error";
      }
    }

    yield put({
      type: "WAIVER_RESPONSE_ADD",
      value: {
        ...response,
        responseStatus,
      },
    });
  } catch (error) {
    yield put({
      type: "WAIVER_RESPONSE_ADD",
      value: {
        ...error,
        responseStatus: "error",
      },
    });
  }
}
function* updateWaiver(actions) {
  const uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const formData = { ...actions.form };

    if (formData.uuid) {
      delete formData.uuid;
    }

    const requestOptions = {
      headers: headers,
      body: JSON.stringify(formData),
    };

    let url = `${apiUrl}/opa-waiver/${actions.waiverUuid}`;

    if (enviromentUrl !== "") {
      url += url.includes("?")
        ? `&env=${enviromentUrl}`
        : `?env=${enviromentUrl}`;
    }

    const response = yield call(apiCall, "PATCH", url, requestOptions);

    let responseStatus = "warning";
    if (response) {
      if (response.updatedAt || response.uuid) {
        responseStatus = "success";
      } else {
        responseStatus = "error";
      }
    }

    yield put({
      type: "WAIVER_RESPONSE_UPDATE",
      value: {
        ...response,
        responseStatus,
      },
    });
  } catch (error) {
    yield put({
      type: "WAIVER_RESPONSE_UPDATE",
      value: {
        ...error,
        responseStatus: "error",
      },
    });
  }
}
function* deleteWaiver(actions) {
  const uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
    };

    let url = apiUrl + "/opa-waiver/" + actions.waiverUuid;

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "DELETE", url, requestOptions);

    let responseStatus = "warning";
    if (response) {
      if (response.status == 200 || response.status == 204) {
        responseStatus = "success";
      } else {
        responseStatus = "error";
      }
    }

    yield put({
      type: "WAIVER_RESPONSE_DELETE",
      value: { ...response, responseStatus },
    });

    return response;
  } catch (error) {
    yield put({
      type: "WAIVER_RESPONSE_DELETE",
      value: { ...error, responseStatus: "error" },
    });
    throw error;
  }
}

function* addWaiverProduct(actions) {
  const uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    if (!actions.form || !actions.form.waiverUuid) {
      yield put({
        type: "WAIVER_PRODUCT_RESPONSE_ADD",
        value: {
          error: "Missing waiver UUID",
          responseStatus: "error",
        },
      });
      return;
    }

    const requestOptions = {
      headers: headers,
      body: JSON.stringify(actions.form.waiverFormData),
    };

    let url = apiUrl + "/opa-waiver/" + actions.form.waiverUuid + "/products";

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "POST", url, requestOptions);

    let responseStatus = "warning";
    if (response) {
      if (Array.isArray(response) || response.success) {
        responseStatus = "success";
      } else {
        responseStatus = "error";
      }
    }

    yield put({
      type: "WAIVER_PRODUCT_RESPONSE_ADD",
      value: {
        ...response,
        responseStatus,
      },
    });
  } catch (error) {
    yield put({
      type: "WAIVER_PRODUCT_RESPONSE_ADD",
      value: {
        error: error.message || "Unknown error",
        responseStatus: "error",
      },
    });
  }
}

function* deleteWaiverProducts(actions) {
  const uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
      body: JSON.stringify(actions.payload.waiverFormData),
    };

    let url =
      apiUrl + "/opa-waiver/" + actions.payload.waiverUuid + "/products";

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "DELETE", url, requestOptions);

    let responseStatus = "warning";
    if (response) {
      if (response.status == 200 || response.status == 204) {
        responseStatus = "success";
      } else {
        responseStatus = "error";
      }
    }

    yield put({
      type: "WAIVER_PRODUCTS_RESPONSE_DELETE",
      value: { ...response, responseStatus },
    });

    return response;
  } catch (error) {
    yield put({
      type: "WAIVER_PRODUCTS_RESPONSE_DELETE",
      value: { ...error, responseStatus: "error" },
    });
    throw error;
  }
}
function* getWaiverProducts(actions) {
  const uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
    };

    let url = `${apiUrl}/opa-waiver/${actions.waiverUuid}`;
    if (enviromentUrl !== "") {
      url += `?env=${enviromentUrl}`;
    }

    const waiverResponse = yield call(apiCall, "get", url, requestOptions);

    if (
      waiverResponse &&
      waiverResponse.products &&
      Array.isArray(waiverResponse.products) &&
      waiverResponse.products.length > 0
    ) {
      yield put({
        type: "WAIVER_PRODUCTS_RESPONSE_GET",
        value: waiverResponse.products,
      });
    } else {
      yield put({ type: "WAIVER_PRODUCTS_RESPONSE_GET", value: [] });
    }
  } catch (error) {
    yield put({ type: "WAIVER_PRODUCTS_RESPONSE_GET", value: [] });
  }
}

function* getProductWaiver(actions) {
  const uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
    };

    let url;
    if (actions.waiverUuid) {
      url = `${apiUrl}/opa-product-waiver/${actions.productUuid}/${actions.waiverUuid}`;
    } else {
      url = `${apiUrl}/opa-product-waiver/${actions.productUuid}`;
    }

    if (enviromentUrl !== "") {
      url += url.includes("?")
        ? `&env=${enviromentUrl}`
        : `?env=${enviromentUrl}`;
    }

    const response = yield call(apiCall, "get", url, requestOptions);
    yield put({ type: "PRODUCT_WAIVER_RESPONSE_GET", value: response });
  } catch (error) {
    yield put({ type: "PRODUCT_WAIVER_RESPONSE_GET", value: error });
  }
}
function* addProductWaivers(actions) {
  const uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
      body: JSON.stringify(actions.form.waiverFormData),
    };

    let url = apiUrl + "/opa-product-waivers/" + actions.form.productUuid;

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "POST", url, requestOptions);

    let responseStatus = "warning";
    if (response) {
      if (Array.isArray(response) || response.success) {
        responseStatus = "success";
      } else {
        responseStatus = "error";
      }
    }

    yield put({
      type: "PRODUCT_WAIVERS_RESPONSE_ADD",
      value: {
        ...response,
        responseStatus,
      },
    });
  } catch (error) {
    yield put({
      type: "PRODUCT_WAIVERS_RESPONSE_ADD",
      value: {
        error: error.message || "Unknown error",
        responseStatus: "error",
      },
    });
  }
}

function* deleteProductWaivers(actions) {
  const uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
      body: JSON.stringify(actions.form.waiverUuids),
    };

    let url = apiUrl + "/opa-product-waivers/" + actions.form.productUuid;

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "DELETE", url, requestOptions);

    let responseStatus = "warning";
    if (response) {
      if (response.status == 200 || response.status == 204) {
        responseStatus = "success";
      } else {
        responseStatus = "error";
      }
    }

    yield put({
      type: "PRODUCT_WAIVERS_RESPONSE_DELETE",
      value: {
        ...response,
        responseStatus,
      },
    });
  } catch (error) {
    yield put({
      type: "PRODUCT_WAIVERS_RESPONSE_DELETE",
      value: {
        error: error.message || "Unknown error",
        responseStatus: "error",
      },
    });
  }
}

export function* getSagaWaiverList() {
  yield takeEvery("GET_LIST_WAIVERS", getWaiverList);
}

export function* getSagaWaiver() {
  yield takeEvery("GET_WAIVER", getWaiver);
}

export function* resetSagaWaiver() {
  yield takeEvery("RESET_WAIVER", resetWaiver);
}

export function* addSagaWaiver() {
  yield takeEvery("ADD_WAIVER", addWaiver);
}

export function* updateSagaWaiver() {
  yield takeEvery("UPDATE_WAIVER", updateWaiver);
}

export function* deleteSagaWaiver() {
  yield takeEvery("DELETE_WAIVER", deleteWaiver);
}

export function* addSagaWaiverProduct() {
  yield takeEvery("ADD_WAIVER_PRODUCT", addWaiverProduct);
}

export function* deleteSagaWaiverProducts() {
  yield takeEvery("DELETE_WAIVER_PRODUCTS", deleteWaiverProducts);
}

export function* getSagaWaiverProducts() {
  yield takeEvery("GET_WAIVER_PRODUCTS", getWaiverProducts);
}

export function* getSagaProductWaiver() {
  yield takeEvery("GET_PRODUCT_WAIVER", getProductWaiver);
}

export function* addSagaProductWaivers() {
  yield takeEvery("ADD_PRODUCT_WAIVERS", addProductWaivers);
}

export function* deleteSagaProductWaivers() {
  yield takeEvery("DELETE_PRODUCT_WAIVERS", deleteProductWaivers);
}
